import React from "react";
export default function Icon(props) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.3333 26.6666H6.66667C5.95942 26.6666 5.28115 26.3857 4.78105 25.8856C4.28095 25.3855 4 24.7072 4 24V7.99998C4 7.29274 4.28095 6.61446 4.78105 6.11436C5.28115 5.61426 5.95942 5.33331 6.66667 5.33331H20C20.7072 5.33331 21.3855 5.61426 21.8856 6.11436C22.3857 6.61446 22.6667 7.29274 22.6667 7.99998V9.33331M25.3333 26.6666C24.6261 26.6666 23.9478 26.3857 23.4477 25.8856C22.9476 25.3855 22.6667 24.7072 22.6667 24V9.33331M25.3333 26.6666C26.0406 26.6666 26.7189 26.3857 27.219 25.8856C27.719 25.3855 28 24.7072 28 24V12C28 11.2927 27.719 10.6145 27.219 10.1144C26.7189 9.61426 26.0406 9.33331 25.3333 9.33331H22.6667M17.3333 5.33331H12M9.33333 21.3333H17.3333M9.33333 10.6666H17.3333V16H9.33333V10.6666Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
